import React, { useContext } from "react";
import { RoleCtx, PayLoadCtx } from "../../lib/context";
import { useHistory, useParams } from 'react-router-dom';
import ConferenceLayout from "./index";
import queryString from 'query-string';

const ConfLayout = (props) => {
    const { role } = useContext(RoleCtx);
    const { payload } = useContext(PayLoadCtx);
    const { id, uid } = useParams();
    const history = useHistory();
    const query_data = queryString.parse(props.location.search);
    return <ConferenceLayout role={role} id={id} uid={uid} history={history} payload={payload} query_data={query_data} />
}
export default ConfLayout;

